module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav-mobile show-sm",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "nav-mobile__close",
    attrs: {
      "href": "#",
      "id": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav--block nav--primary"
  }, [_c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('about')
    }
  }, [_vm._v("เกี่ยวกับ กสศ.")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('our-work')
    }
  }, [_vm._v("งานของเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('fund')
    }
  }, [_vm._v("ทุน")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('knowledge')
    }
  }, [_vm._v("คลังสมอง")])]), _vm._v(" "), _c('li', {
    staticClass: "nav__item"
  }, [_c('a', {
    staticClass: "nav__link",
    attrs: {
      "href": _vm.$utils.getWpPath('contact')
    }
  }, [_vm._v("ติดต่อ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0e96b9a9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e96b9a9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenu.vue
// module id = 722
// module chunks = 1